import { classes } from 'html-classes';
import { useTranslation } from 'react-i18next';

import Button from '~/components/isolated/Button/Button';
import { IconButton } from '~/components/isolated/IconButton';
import { ModalProps } from '~/components/Modal/interface';
import Modal from '~/components/Modal/Modal';
import { useGlobal } from '~/hooks/useGlobal';
import { useModal } from '~/hooks/useModal';

import styles from './ModalSaveMore.module.scss';

interface ModalSaveMoreProps extends Omit<ModalProps, 'children'> {
  children: React.ReactNode;
}

const ModalSaveMore = ({
  isShow,
  className,
  children,
  ...props
}: ModalSaveMoreProps) => {
  const { t } = useTranslation();
  const { isMobile } = useGlobal();
  const { closeModal } = useModal();

  const handleCloseModal = () => {
    props.onBackdropDismiss?.(closeModal);
    closeModal();
  };

  return (
    <Modal
      {...props}
      isShow={isShow}
      className={classes([styles.modal, className])}
    >
      <div className={styles.content}>
        <div className={styles.title}>
          <h2 className={styles.titleText}>{t('phrases:saveMore')}</h2>
          {!isMobile && (
            <IconButton
              variant="outline"
              size="S"
              icon="close"
              onClick={handleCloseModal}
            />
          )}
        </div>
        {children}
        <div className={styles.buttons}>
          <Button
            variant="primary"
            size="L"
            className={styles.button}
            onClick={handleCloseModal}
          >
            {t('okayButton')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ModalSaveMore;
